import Icon from '@mui/icons-material/DoneOutline';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function DoneIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
